module.exports = __webpack_public_path__ + "media/1x1/sv-26ee8872.svg";